import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../../assets/css/animate.min.css';
import '../../assets/css/bootstrap.css';
import '../../assets/css/style.css';
import '../../assets/css/font-awesome.min.css';
import './home.css';
import { FaBars, FaTimes } from "react-icons/fa";
import { FiUser, FiUserPlus } from "react-icons/fi";
import { LoginContext } from '../../context/LoginContext';
import { SignupContext } from '../../context/SignupContext';
import { brandLogo, brandFallback } from '../../constants/brandAssets';

const AUTH_PATHS = [
  '/login',
  '/sign-up',
  '/signup',
  '/create-profile',
  '/desired-partner',
  '/account-pending-approval',
  '/send-otp',
  '/otp',
  '/forgot-password',
  '/fogot-password',
  '/reset-password',
  '/verify-account',
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, isLoggedIn } = useContext(LoginContext);
  const { clearSignup } = useContext(SignupContext);

  const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  const hideAuthButtons = AUTH_PATHS.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );

  // Close open menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.search]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goLogin = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      logout();
    }
    if (typeof clearSignup === 'function') {
      clearSignup();
    }
    navigate('/login?force=1', { replace: true });
    setIsMenuOpen(false);
  };

  const goSignup = () => {
    setIsMenuOpen(false);
  };

  const isHome = path === '/';

  return (
    <header className="header-luxury-container">
      <div className="container-fluid px-3 px-lg-5">
        <div className="header-luxury-inner">
          {/* Brand Logo */}
          <div className="header-brand">
            <Link to="/" className="brand-link">
              <img
                src={brandLogo}
                alt="Hindu Sanjog"
                className="brand-logo-img"
                onError={(e) => {
                  if (e.currentTarget.src !== brandFallback) {
                    e.currentTarget.src = brandFallback;
                  }
                }}
              />
            </Link>
          </div>

          {/* Right Action Buttons */}
          <div className="header-actions">
            {!hideAuthButtons ? (
              <div className="d-none d-sm-flex align-items-center gap-2">
                <button type="button" className="btn-luxury-login" onClick={goLogin}>
                  <FiUser className="btn-icon" />
                  <span>{isLoggedIn ? 'Logout' : 'Login'}</span>
                </button>
                <Link to="/login?mode=signup" className="btn-luxury-register" onClick={goSignup}>
                  <FiUserPlus className="btn-icon" />
                  <span>Sign Up</span>
                </Link>
              </div>
            ) : (
              <div className="d-none d-sm-flex">
                <Link to="/" className="btn-luxury-login">
                  <span>Home</span>
                </Link>
              </div>
            )}

            {/* Mobile Hamburger Button */}
            <button
              className="menu-luxury-toggle d-lg-none"
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Drawer */}
        {isMenuOpen && (
          <div className="mobile-luxury-menu d-lg-none">
            <div className="mobile-auth-actions mt-2">
              {!hideAuthButtons ? (
                <div className="d-flex gap-2">
                  <button type="button" className="btn-luxury-login flex-fill justify-content-center" onClick={goLogin}>
                    <FiUser className="btn-icon" />
                    <span>{isLoggedIn ? 'Logout' : 'Login'}</span>
                  </button>
                  <Link to="/login?mode=signup" className="btn-luxury-register flex-fill justify-content-center" onClick={goSignup}>
                    <FiUserPlus className="btn-icon" />
                    <span>Sign Up</span>
                  </Link>
                </div>
              ) : (
                <Link to="/" className="btn-luxury-login w-100 text-center" onClick={() => setIsMenuOpen(false)}>
                  Home
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
